import "./index.less";

import React, { ReactElement, useEffect, useState } from "react";
import { UserSettingLayoutContainer } from "../UserSettingLayoutContainer";
import { RemoI18nTFunction, useTranslate } from "@obsbot/remo-i18n";
import { withRemoServices } from "../../components/RemoServicesContext";
import AudioSettingPage from "./components/AudioSettingPage";
import VideoSettingPage from "./components/VideoSettingPage";
import { PreferencesStoreState, useGlobalStore, usePreferencesStore } from "@obsbot/remo-stores";
import { IServiceVideoChat } from "@obsbot/remo-services";
import { useLocation } from "react-router-dom";

enum RTCSettingTab {
    AudioSetting = "audioSetting",
    VideoSetting = "videoSetting",
}

export type SettingComponentsType = {
    t: RemoI18nTFunction;
    rtc: IServiceVideoChat;
    preference: PreferencesStoreState | undefined;
};

const RTCSettingPage = withRemoServices("videoChat")(({ videoChat: rtc }): ReactElement => {
    const location = useLocation();
    const [tab, setTab] = useState<RTCSettingTab>(RTCSettingTab.AudioSetting);
    const t = useTranslate();
    const globalStore = useGlobalStore();
    const preferenceStore = usePreferencesStore(globalStore.userInfo?.user_id ?? "")?.(
        state => state,
    );
    useEffect(() => {
        if (location.state && location.state.tab === RTCSettingTab.VideoSetting) {
            setTab(RTCSettingTab.VideoSetting);
        }
    }, [location.state]);
    return (
        <UserSettingLayoutContainer>
            <div className="rtc-setting-container">
                <div className="rtc-setting-switch-setting">
                    {Object.values(RTCSettingTab).map(item => {
                        return (
                            <div
                                key={item}
                                className={
                                    tab === item
                                        ? "rtc-setting-tab-item active"
                                        : "rtc-setting-tab-item"
                                }
                                onClick={() => setTab(item)}
                            >
                                {t(`settings.rtc-setting.${item}`)}
                            </div>
                        );
                    })}
                </div>
                {tab === RTCSettingTab.AudioSetting ? (
                    <AudioSettingPage preference={preferenceStore} rtc={rtc} t={t} />
                ) : (
                    <VideoSettingPage preference={preferenceStore} rtc={rtc} t={t} />
                )}
            </div>
        </UserSettingLayoutContainer>
    );
});

export default RTCSettingPage;
